import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const routeMap: Record<string, string> = {
  '/': '首页',
  '/category': '分类',
  '/category/live': '赛事直播',
  '/category/data': '数据分析',
  '/category/interactive': '足球互动',
  '/category/events': '最新活动',
  '/article': '文章',
  '/about': '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (location.pathname === '/') return null;

  const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  let currentPath = '';
  pathSegments.forEach((segment) => {
    currentPath += `/${segment}`;
    const label = routeMap[currentPath] || segment;
    breadcrumbs.push({
      label,
      href: currentPath === location.pathname ? undefined : currentPath,
    });
  });

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3 bg-background-100/50">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {breadcrumbs.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}